import React, { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { Typography, List, ListItem } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { routes } from '../../constants/routes'

const useStyles = makeStyles((theme: Theme) => ({
  nav: {
    display: 'flex',
    alignItems: 'center',
  },
  navItem: {
    width: 'auto',
    paddingLeft: 0,
    paddingRight: 50,
  },
  navLink: {
    textDecoration: 'none',
    color: theme.palette.primary.light,
    '&.MuiLink-underlineHover:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
  },
  navText: {
    fontSize: 14,
  },
  navLogin: {
    color: theme.palette.secondary.light,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 12,
    letterSpacing: 1,
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: 28,
    padding: '12px 32px',
  },
}))

export const Navigation: FC = () => {
  const classes = useStyles()
  return (
    <List component="nav" aria-label="main mailbox folders" className={classes.nav}>
      <ListItem className={classes.navItem}>
        <NavLink to={routes.LOGIN} className={classes.navLink}>
          <Typography className={classes.navLogin}>Login</Typography>
        </NavLink>
      </ListItem>
      <ListItem className={classes.navItem}>
        <NavLink to={routes.PRIVACY_POLICY} className={classes.navLink}>
          <Typography className={classes.navText}>Privacy Policy</Typography>
        </NavLink>
      </ListItem>
      <ListItem className={classes.navItem}>
        <NavLink to={routes.CONTACT} className={classes.navLink}>
          <Typography className={classes.navText}>Contact us</Typography>
        </NavLink>
      </ListItem>
    </List>
  )
}
